import styled from "styled-components";
import { style } from "./style";

export const Backdrop = styled.div`
  position: fixed;
  top: -100vh;
  height: 200vh;
  left: 0;
  right: 0;
  background-color: ${style.colors.backdrop};
  z-index: ${style.vars.zIndex.raised};
`;
